<div class="multiline-cell">
  <ul>
    @for (value of dataContext; track $index) {
      <li>@if (value) { {{ value }} } @else { &nbsp; }</li>
    }
  </ul>
</div>
